<template>
  <modal class="base-modal" :classes="['base-modal__box']"
         v-bind="$attrs"
         v-on="$listeners">
    <div class="base-modal__content" :class="{'base-modal__content--padding': !noPadding}">
      <button class="base-modal__close" @click="$modal.hide($attrs.name)">
          <font-awesome-icon :icon="['far','times']" />
      </button>
      <div v-if="title" class="tw-pb-4">
          <div class="tw-text-xl tw-font-bold tw-text-infinity-highlight ">{{ title }}</div>
          <div class="tw-text-sm tw-text-infinity-tertiary-text">{{ subtitle }}</div>
      </div>
      <slot></slot>
      <div v-if="okButton" class="tw-pt-4 tw-flex tw-justify-end tw--mb-2">
          <button class="c-button c-button--default" @click="$modal.hide($attrs.name)">
              {{ okButton === true ? 'Ok' : okButton }}
          </button>
      </div>
    </div>
  </modal>
</template>
<script>
import "vue-js-modal/dist/styles.css";

export default {
  inheritAttrs: false,
  name: "base-modal",
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    okButton: {
      type: [String, Boolean]
    }
  }
};
</script>
<style lang="scss">
.base-modal {
  &.v--modal-overlay {
    @apply tw-bg-infinity-background-faded-modal tw-backdrop-filter tw-backdrop-blur;

    z-index: 2000;

    .base-modal__box {
      @apply tw-overflow-visible tw-px-2 tw-py-16;
    }

    .base-modal__content {
      @apply tw-bg-infinity-background-emphasized tw-rounded-xl tw-shadow tw-relative;

      &--padding {
        @apply tw-p-5;

        @screen sm {
          @apply tw-p-8;
        }
      }
    }
  }

  &__close {
    @apply tw-border-none
    tw-absolute
    tw-bg-infinity-button-background
    tw-text-infinity-button-text
    tw-w-8
    tw-h-8
    tw-flex
    tw-items-center
    tw-justify-center
    tw--mt-12
    tw-rounded-full
    tw-text-base
    tw-shadow
    tw-right-0
    tw-top-0
    tw-transition
    hover:tw-bg-infinity-button-hover-background
    ;
  }
}
</style>
